import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITicketBooking, ITicketBookingState } from "./ticketBookingModel";
import { getAllTicketBooking } from "./services/ticketBooking.services";

const initialState: ITicketBookingState = {
  loading: false,
  error: "",
  TicketBookingID: null,
  TicketBookingTabIndex: 0,
  TicketBookingList: [],
  FilterTicketBooking: {
    Name: "",
    EmailID: "",
    MobileNo: "",
    City: "",
    VisitDate: "",
    BookingStatus: "",
    FromDate: "",
    ToDate: "",
  },
};

const ticketBookingSlice = createSlice({
  name: "ticketBooking",
  initialState,
  reducers: {
    clearTicketBookingList: (state) => {
      state.TicketBookingList = [];
    },
    setFilterTicketBooking: (state, action) => {
      state.FilterTicketBooking = action.payload;
    },
    clearFilterTicketBooking: (state) => {
      state.FilterTicketBooking = initialState.FilterTicketBooking;
    },
    setTicketBookingTabIndex: (state, action) => {
      state.TicketBookingTabIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTicketBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTicketBooking.fulfilled,
      (state, action: PayloadAction<ITicketBooking[]>) => {
        state.loading = false;
        state.TicketBookingList = action.payload || [];
      }
    );
    builder.addCase(getAllTicketBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TicketBookingList = [];
    });
  },
});

export const {
  clearTicketBookingList,
  setFilterTicketBooking,
  clearFilterTicketBooking,
  setTicketBookingTabIndex,
} = ticketBookingSlice.actions;
export default ticketBookingSlice.reducer;
